export default "__VITE_ASSET__DQtAjhjA__"